import React, { useEffect, useState } from "react";
import QRCode from "qrcode";
import { clubShareLink } from "../../../../utils/deepLinks";
import { useCopyText } from "../../lib/clipboard";
import { useToast } from "../../components/Toast";
import { Button, Card, ClubLogo } from "../../components/primitives";

// dark = --ink, light = --white (the QR library needs literal colours).
const QR_OPTS = { margin: 2, width: 1024, color: { dark: "#0B0B12", light: "#FFFFFF" } };

function download(href, name) {
  const a = document.createElement("a");
  a.href = href;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/** Share tab (components/admin/ClubShareTab.js): QR of clubShareLink(club.id), copy link, download PNG. */
export default function ShareTab({ club }) {
  const toast = useToast();
  const copy = useCopyText();
  const link = clubShareLink(club.id);
  const [png, setPng] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let live = true;
    setPng(null);
    setFailed(false);
    QRCode.toDataURL(link, QR_OPTS).then(
      (url) => { if (live) setPng(url); },
      () => { if (live) setFailed(true); }
    );
    return () => { live = false; };
  }, [link]);

  const savePng = () => {
    if (!png) return;
    download(png, `club-qr-${club.id}.png`);
    toast("QR saved as PNG");
  };

  return (
    <Card pad className="col" style={{ alignItems: "center", textAlign: "center", gap: 14 }}>
      <ClubLogo club={club} size={56} />
      <b style={{ fontSize: 18 }}>{club.name}</b>
      <div className="qr">
        {png ? <img className="mg-qr-img" src={png} alt={`QR code for ${club.name}`} /> : <div className="mg-qr-img" aria-busy="true" />}
      </div>
      {failed && <span className="err-text" role="alert">Couldn&apos;t generate the QR code.</span>}
      <span className="meta">Scan this code to join {club.name} on VibeLink</span>
      <span className="meta ellip" style={{ maxWidth: "100%" }}>{link}</span>
      <div className="row wrap" style={{ justifyContent: "center" }}>
        <Button size="sm" icon="link" onClick={() => copy(link, "Link copied")} data-testid="manage.share.copyLink">Copy link</Button>
        <Button variant="sec" size="sm" icon="download" onClick={savePng} disabled={!png} data-testid="manage.share.downloadPng">Download PNG</Button>
      </div>
    </Card>
  );
}
